<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->
      <div
        v-show="$route.path != '/Master/ManageBarcode/Import'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-barcode"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ pageTitle }}
            </h3>
          </div>
        </div>
        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" @submit="formSubmit" ref="searchForm">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="label mb-1">BARCODE :</label>
                  <input
                    v-model="MbOldBarcode"
                    type="text"
                    class="form-control"
                    placeholder="BARCODE"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="label mb-1">รหัสทรัพย์สิน(เบียร์สด) :</label>
                  <input
                    v-model="MbDepartmentMaterialCode"
                    type="text"
                    class="form-control"
                    placeholder="รหัสทรัพย์สิน(เบียร์สด)"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="label mb-1">รหัสทรัพย์สิน(บัญชี) :</label>
                  <input
                    v-model="MbAccountMaterialCode"
                    type="text"
                    class="form-control"
                    placeholder="รหัสทรัพย์สิน(บัญชี)"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="label mb-1">BARCODE COOLING :</label>
                  <input
                    v-model="MbBarcodeCooling"
                    type="text"
                    class="form-control"
                    placeholder="BARCODE COOLING"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="label mb-1">ประเภทสินค้า :</label>
                  <treeselect
                    v-model="MbProductTypeId"
                    :multiple="true"
                    :options="MbProductTypeIdOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="label mb-1">ชื่อสินค้า :</label>
                  <treeselect
                    v-model="MbAssetCode"
                    :multiple="true"
                    :options="MbAssetCodeOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="label mb-1">แบรนด์สินค้า :</label>
                  <treeselect
                    v-model="MbBrandId"
                    :multiple="true"
                    :options="MbBrandIdOptions"
                    v-on:select="BrandIdClearAfterSelect"
                    v-on:deselect="BrandIdClearAfterDeSelect"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="label mb-1">ชื่อแบรนด์สินค้า :</label>
                  <treeselect 
                    v-model="ProductIdBrand"
                    :multiple="true"
                    :options="filteredProductIdBrandOptions"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-if="this.$root.canShow(['MANAGE_MASTER','MANAGE_BARCODE_AGENT'])">
                <div class="form-group mb-3">
                  <label class="label mb-1">ชื่อตัวแทนจำหน่าย :</label>
                  <treeselect
                    v-model="MbHostAgentCode"
                    :multiple="true"
                    :options="MbHostAgentCodeOptions"
                    v-on:select="AgentCodeClearAfterSelect"
                    v-on:deselect="AgentCodeClearAfterDeSelect"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-if="this.$root.canShow(['MANAGE_MASTER','MANAGE_BARCODE_AGENT','MANAGE_BARCODE_SUB_AGENT'])">
                <div class="form-group mb-3">
                  <label class="label mb-1">ชื่อตัวแทนจำหน่ายย่อย :</label>
                  <treeselect 
                    v-model="MbHostSubAgentCode"
                    :multiple="true"
                    :options="filteredSubAgentOptions"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-if="this.$root.canShow(['MANAGE_MASTER','MANAGE_BARCODE_AGENT'])">
                <div class="form-group mb-3" v-if="this.$root.canShow(['super_admin'])">
                  <label class="label mb-1">สถานะทรัพย์สินเช่า:</label>
                  <treeselect 
                    id="IsLeasedAssets"
                    v-model="IsLeasedAssets"
                    :options="LeasedAssetsOptions"
                    placeholder="กรุณาเลือก"
                    ref="IsLeasedAssets"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-if="this.$root.canShow(['MANAGE_MASTER','MANAGE_BARCODE_AGENT'])">
                <div class="form-group mb-3" v-if="showActiveStatusFilter">
                  <label class="label mb-1">
                    สถานะใช้งาน:
                    <a
                      href="#"
                      class="ml-1"
                      ref="ActiveStatusInfo"
                      data-toggle="popover"
                      data-trigger="focus"
                      data-placement="bottom"
                      data-html="true"
                      :data-content="ActiveStatusInfoText"
                      @click.prevent
                    ><i class="fa fa-info-circle"></i></a>
                  </label>
                  <treeselect
                    id="ActiveStatus"
                    v-model="ActiveStatus"
                    :options="ActiveStatusOptions"
                    placeholder="กรุณาเลือก"
                    ref="ActiveStatus"
                  />
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-if="this.$root.canShow(['MANAGE_MASTER'])">
                <div class="form-group mb-3">
                  <label class="label mb-1">เจ้าของทรัพย์สิน :</label>
                  <treeselect
                    v-model="MbAssetOwnerId"
                    :multiple="true"
                    :options="MbAssetOwnerOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="label mb-1">ประเภทผู้ถือครอง:</label>
                  <treeselect 
                    id="MbCurrentLocationType"
                    v-model="MbCurrentLocationType"
                    :options="MbCurrentLocationTypeOptions"
                    placeholder="กรุณาเลือก"
                    ref="MbCurrentLocationType"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="label mb-1">ปี(สินค้า):</label>
                  <treeselect
                    v-model="MbBarcodeYear"
                    :multiple="true"
                    :load-options="LoadBarcodeYearOptions"
                    v-on:open="reLoadBarcodeYearOptions"
                    :async="true"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="true"
                    ref="MbBarcodeYear"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group mb-3">
                  <label class="label mb-1">สถานะ :  
                    <input type="checkbox" v-model="MbIsShowCancel" v-bind:value="false" 
                    v-on:click="clickcheckbox()"
                    > แสดงข้อมูลสถานะยกเลิก
                  </label>
                  
                  <treeselect 
                    id="MbBarcodeStautsId"
                    v-model="MbBarcodeStautsId"
                    :disabled = "MbBarcodeStautsDisabled"
                    :multiple="true"
                    :options="MbBarcodeStatusOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-if="this.$root.canShow(['MANAGE_MASTER'])">
                <div class="form-group mb-3">
                  <label class="label mb-1">Supplier ที่ซื้อเข้า:</label>
                  <treeselect
                    v-model="MbSupplierId"
                    :multiple="true"
                    :load-options="LoadMbSupplierOptions"
                    :async="true"
                    :cacheOptions="true"
                    v-on:open="reLoadMbSupplierOptions"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    ref="MbSupplierId"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-if="this.$root.canShow(['MANAGE_MASTER'])">
                <div class="form-group mb-3">
                  <label class="label mb-1">อายุของทรัพย์สิน(วัน) :</label>
                  <input
                    id="MbExprie"
                    name="MbExprie"
                    v-model="MbExprie"
                    type="text"
                    class="form-control"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-if="this.$root.canShow(['MANAGE_MASTER'])">
                <div class="form-group mb-3">
                  <label class="label mb-1">ระยะเวลาประกัน(วัน) :</label>
                  <input
                    id="MbWarrantyTime"
                    name="MbWarrantyTime"
                    v-model="MbWarrantyTime"
                    type="text"
                    class="form-control"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3" v-if="this.$root.canShow(['MANAGE_MASTER'])">
                <div class="form-group mb-3">
                  <label class="label mb-1">รหัสอ้างอิง:</label>
                  <treeselect
                    v-model="MbRefNo"
                    :multiple="true"
                    :load-options="LoadMbRefNoOptions"
                    :async="true"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="true"
                  />
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <!-- <div class="kt-portlet__head kt-portlet__head--lg"> -->
              <div class="kt-portlet__head-label">
                <h5 class="kt-portlet__head-title">ค้นหาที่ตั้งปัจจุบัน</h5>
              </div>
              <!-- </div> -->
            </div>
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4" v-if="this.$root.canShow(['MANAGE_MASTER','MANAGE_BARCODE_AGENT'])">
                <div class="form-group mb-3">
                  <label class="label mb-1">ตัวแทนจำหน่าย :</label>
                  <treeselect
                    v-model="MbAgentId"
                    :multiple="true"
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :options="MbAgentOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                    ref="MbAgentId"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4" v-if="this.$root.canShow(['MANAGE_MASTER','MANAGE_BARCODE_AGENT'])">
                <div class="form-group mb-3">
                  <label class="label mb-1">ร้านค้า(ตัวแทน) :</label>
                  <treeselect
                    id="MbShopId"
                    v-model="MbShopId"
                    :async="true"
                    :multiple="true"
                    :load-options="LoadMbShopOptions"
                    v-on:open="reLoadMbShopOptions"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                    ref="MbShopId"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4" v-if="this.$root.canShow(['MANAGE_MASTER','MANAGE_BARCODE_AGENT'])">
                <div class="form-group mb-3">
                  <label class="label mb-1">ร้านค้า2(ตัวแทน) :</label>
                  <treeselect
                    id="MbShop2Id"
                    v-model="MbShop2Id"
                    :async="true"
                    :multiple="true"
                    :load-options="LoadMbShop2Options"
                    v-on:open="reLoadMbShop2Options"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                    ref="MbShop2Id"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group mb-3">
                  <label class="label mb-1">ร้านค้า(ตัวแทนจำหน่ายย่อย) :</label>
                  <treeselect
                    ref="MbSupShopId"
                    v-model="MbSupShopId"
                    :multiple="true"
                    :load-options="LoadMbSupShopOptions"
                    :async="true"
                    v-on:open="reLoadMbSupShopOptions"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4">
                <div class="form-group mb-3">
                  <label class="label mb-1">ร้านค้า2(ตัวแทนจำหน่ายย่อย) :</label>
                  <treeselect
                    ref="MbSupShop2Id"
                    v-model="MbSupShop2Id"
                    :multiple="true"
                    :load-options="LoadMbSupShop2Options"
                    :async="true"
                    v-on:open="reLoadMbSupShop2Options"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4" v-if="this.$root.canShow(['MANAGE_MASTER'])">
                <div class="form-group mb-3">
                  <label class="label mb-1">ผู้ดูแลทรัพย์สิน(ตัวแทน) :</label>
                  <treeselect
                    id="MbIntendantId"
                    v-model="MbIntendantId"
                    :async="true"
                    :multiple="true"
                    :load-options="LoadMbIntendant"
                    v-on:open="reLoadMbIntendant"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                    ref="MbIntendantId"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4" v-if="this.$root.canShow(['MANAGE_MASTER'])">
                <div class="form-group mb-3">
                  <label class="label mb-1">ผู้ดูแลทรัพย์สิน(ตัวแทนจำหน่ายย่อย) :</label>
                  <treeselect
                    id="MbIntendantSubShopId"
                    v-model="MbIntendantSubShopId"
                    :async="true"
                    :multiple="true"
                    :load-options="LoadMbIntendantSubShop"
                    v-on:open="reLoadMbIntendantSubShop"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="false"
                    ref="MbIntendantSubShopId"
                  >
                    <label slot="option-label" slot-scope="{ node }">
                      {{ node.label }}
                    </label>
                  </treeselect>
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4" v-if="this.$root.canShow(['MANAGE_MASTER'])">
                <div class="form-group mb-3">
                  <label class="label mb-1">คลัง :</label>
                  <treeselect
                    v-model="MbPlantId"
                    :multiple="true"
                    :options="MbPlantOptions"
                    :clear-on-select="true"
                    placeholder="กรุณาเลือก"
                  />
                </div>
              </div>
              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-4" v-if="this.$root.canShow(['MANAGE_MASTER'])">
                <div class="form-group mb-3">
                  <label class="label mb-1">Supplier:</label>
                  <treeselect
                    v-model="MbCurrentSupplierId"
                    :multiple="true"
                    :load-options="LoadMbCurrentSupplierOptions"
                    :async="true"
                    v-on:open="reLoadMbCurrentSupplierOptions"
                    v-on:select="ClearAfterselect"
                    searchPromptText="กรุณาพิมพ์คำที่ต้องการค้นหา"
                    placeholder="กรุณาเลือก"
                    :cacheOptions="true"
                    ref="MbCurrentSupplierId"
                  />
                </div>
              </div>
            </div>
            <div class="row mt-3 mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">ค้นหา</button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>
              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportBarcode"
                  type="submit"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
                <router-link
                  to="ManageBarcode/Import"
                  tag="button"
                  title="เพิ่มข้อมูล BARCODE(Excel)"
                  class="btn btn-outline-brand"
                  v-if="this.$root.canShow(['MANAGE_MASTER'])"
                >
                  <i class="fas fa-file-import"></i> Import
                </router-link>
                <router-link
                  to="ManageBarcode/TemplateBarcode"
                  tag="button"
                  title="ดาวน์โหลด Template Barcode"
                  class="btn btn-outline-brand"
                  v-if="this.$root.canShow(['MANAGE_MASTER'])"
                >
                  <i class="fas fa-download"></i> Template
                </router-link>
                <router-link
                  to="ManageBarcode/DownloadBarcode"
                  tag="button"
                  title="ดาวน์โหลด BARCODE"
                  class="btn btn-outline-brand"
                  v-if="this.$root.canShow(['MANAGE_MASTER'])"
                >
                  <i class="fas fa-file-export"></i> Download
                </router-link>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->
          <!--begin: Datatable -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable"
                id="barcodeTable"
              >
                <thead>
                  <tr>
                    <th class="all" style="width: 10%;">BARCODE</th>
                    <th class="all">รหัสทรัพย์สิน(เบียร์สด)</th>
                    <th class="all">รหัสทรัพย์สิน(บัญชี)</th>
                    <th class="all">BARCODE COOLING</th>
                    <th class="all">รหัสสินค้า</th>
                    <th class="all">ชื่อสินค้า</th>
                    <th class="all">ประเภทสินค้า</th>
                    <th class="all">รหัสแบรนด์สินค้า</th>
                    <th class="all">ชื่อแบรนด์สินค้า</th>
                    <th class="all">สถานะสินค้า</th>
                    <th class="all">ผู้ถือครอง</th>
                    <th class="all">ผู้ดูแลทรัพย์สิน</th>
                    <th class="all">ประเภทผู้ถือครอง</th>
                    <th class="none">รหัสอ้างอิง</th>
                    <th class="none">วันที่เริ่มต้น</th>
                    <th class="none">ระยะเวลาประกัน(วัน)</th>
                    <th class="none">อายุของทรัพย์สิน(วัน)</th>
                    <th class="none">Supplier</th>
                    <th class="all" style="width: 120px; max-width: 120px; text-align: center;">การจัดการ</th>
                  </tr>
                </thead>
              </table>
            </div>
          </div>
          <!--end: Datatable -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import router from "../../../router";
import select2 from "../../../Shared/Select2";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import DatatableWarning from "../../../Shared/DatatableWarning";

const simulateAsyncOperation = (fn) => {
  setTimeout(fn, 2000);
};

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

let Actions = Vue.extend({
  template: `
  <div>
    <a href="#" @click.prevent="detail" v-if="data.showDetailButton" title="รายละเอียด" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="fa fa-search"></i>
    </a>
    <a href="#" @click.prevent="editBarCode" v-if="data.showEditBarCodeButton" title="แก้ไขข้อมูล BARCODE" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-edit"></i>
    </a>
     <a href="#" @click.prevent="toggleStatus(data)" v-if="data.showCancelBarCodeButton" title="ยกเลิก BARCODE" class="btn btn-sm btn-clean btn-icon btn-icon-md">
      <i class="la la-trash text-danger" ></i>
    </a>
  </div>`,
  methods: {
     
    toggleStatus: function(e) {
        let self = this;
      axios
            .get(
              "/Api/Barcode/" +
                this.data.barcodeId + 
                "/ValidateBarcodeMapping"
            )
            .then(function(response) {
 
              if (response.data.data=="") {
                // no confirm
                self.submittoggle("A0");
              } else {
                // confirm again
                Swal.fire({
                title: "คำสั่งแก้ไขสถานะ",
                type: "warning",
                html: response.data.message ,
                inputPlaceholder: "ต้องการแก้ไขสถานะ",
                showCancelButton: true,
                confirmButtonText: "ยืนยัน",
                cancelButtonText: "ยกเลิก",
                showLoaderOnConfirm: true,
              }).then((result) => {
                if (result.value === true || result.value === false) {
                   self.submittoggle(response.data.data);
                }
              });
              }
            })
            .catch(function(error) {
              Swal.fire("เกิดข้อผิดพลาด", "ไม่สามารถดำเนินการได้", "error");
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });

      
    },
    submittoggle : function(mastermappingid){
      let self = this;
      var table = $("#barcodeTable");
      if(mastermappingid!=null && mastermappingid.length > 10){
        self.submitCancel(mastermappingid);
      }
      else{
        Swal.fire({
          title: "คำสั่งแก้ไขสถานะ",
          type: "warning",
          html:
            "กรุณายืนยันการยกเลิกรายการ BARCODE" ,
          inputPlaceholder: "ต้องการแก้ไขสถานะ",
          showCancelButton: true,
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value === true || result.value === false) {
            self.submitCancel(mastermappingid);
          }
        });
      }
    },
    submitCancel  :function(mastermappingid){
       let self = this;
      var table = $("#barcodeTable");
      KTApp.blockPage({
            opacity: 0.05,
            message: "กำลังแก้ไข้ข้อมูล กรุณารอสักครู่...",
          });

          axios
            .put(
              "/Api/Barcode/" +
                this.data.barcodeId + 
                "/"+mastermappingid +
                "/Toggle"
            )
            .then(function(response) {
              if (response.data.data) {
                self.$parent.reloadDataTable();
                Swal.fire("สำเร็จ", "ยกเลิก BARCODE สำเร็จ", "success");
              } else {
                Swal.fire(
                  "เกิดข้อผิดพลาด",
                  response.data.message,
                  "error"
                );
              }
            })
            .catch(function(error) {
              Swal.fire(
                "เกิดข้อผิดพลาด",
                (error.response && error.response.data && error.response.data.message) ||
                  "ไม่สามารถดำเนินการได้",
                "error"
              );
            })
            .then(function() {
              // always executed
              KTApp.unblockPage();
            });
    },
    detail: function() {
      router.push({
        path: `/Master/ManageBarcode/Detail/${this.data.barcodeId}`,
      });
    },
    editBarCode: function() {
      router.push({
        path: `/Master/ManageBarcode/EditBarCode/${this.data.barcodeId}`,
      });
    },
  },
});

export default {
  components: {
    select2,
    Treeselect,
  },
  data: function() {
    var self = this;
    
    return {
      MbIsShowCancel : false ,
      MbWarrantyTime: null,
      MbExprie: null,
      MbProductTypeId: [],
      MbAssetOwnerId: [],
      MbAgentId: [],
      MbPlantId: [],
      MbShopId: [],
      MbShop2Id: [],
      MbIntendantId: [],
      MbIntendantSubShopId: [],
      MbSupShopId: [],
      MbSupShop2Id: [],
      MbSupplierId: [],
      MbCurrentSupplierId: [],
      MbBarcodeStautsId: [],
      MbBarcodeStautsDisabled : false ,
      MbOldBarcode: "",
      MbBarcodeCooling: "",
      MbDepartmentMaterialCode: "",
      MbAccountMaterialCode: "",
      MbCurrentSupplierOptions: [],
      MbRefNo: [],
      MbRefNoOptions: [],
      MbBarcodeStatusOptions: [],
      MbSupplierOptions: [],
      MbShopOptions: [],
      MbSupShopOptions: [],
      MbPlantOptions: [],
      MbAgentOptions: [],
      MbProductTypeIdOptions: [],
      MbAssetOwnerOptions: [],
      MbIntendantOptions:[],
      MbIntendantSubShopOptions:[],
      MbDepartmentMaterialCodeOptions: [],
      MbAssetCode: [],
      MbAssetCodeOptions: [],
      MbBrandId: [],
      MbBrandIdOptions: [],
      ProductIdBrand: [],
      ProductIdBrandOptions: [],
      fullProductData: [],
      fullSubAgentData: [],
      MbHostAgentCode: [],
      MbHostAgentCodeOptions: [],
      MbHostSubAgentCode: [],
      reBHostSubAgentCodeOptions: [],
      MbCurrentLocationType: null,
      MbCurrentLocationTypeOptions: [],
      MbBarcodeYear: [],
      AllBarcodeYearOptions: [],
      IsLeasedAssets: null,
      LeasedAssetsOptions: [],
      // CR 02/09/2026 — filter "สถานะใช้งาน" (1=ใช้งาน เป็นค่าเริ่มต้น, 0=ปิดใช้งาน, null=ทั้งหมด)
      ActiveStatus: 1,
      ActiveStatusOptions: [],
      ActiveStatusInfoText:
        'ใช้งาน = ไม่แสดงข้อมูล BARCODE ที่ คอลัมน์ "ผู้ดูแลทรัพย์สิน" 1.Z000002 คลัง Writeoff(ตัวแทนจำหน่าย), 2.คลังสินค้าที่ตั้งค่า "ประเภทคลังสินค้า = คลัง(จัดการข้อมูล)"<br/>*กำหนดเป็นค่าเริ่มต้น<br/>ปิดใช้งาน = แสดงข้อมูล BARCODE ที่ คอลัมน์ "ผู้ดูแลทรัพย์สิน" 1.Z000002 คลัง Writeoff(ตัวแทนจำหน่าย), 2.คลังสินค้าที่ตั้งค่า "ประเภทคลังสินค้า = คลัง(จัดการข้อมูล)"',
    };
  },
  computed: {
    // CR 02/09/2026 — ไม่แสดง filter "สถานะใช้งาน" ให้สิทธิ์ แอดมินตัวแทนจำหน่าย / แอดมินตัวแทนจำหน่ายย่อย
    // (super_admin เห็นเสมอ — canShow คืน true ให้ super_admin ทุกกรณี จึงต้องใช้ canShowExSuperAdmin)
    showActiveStatusFilter() {
      return (
        this.$root.canShow(["super_admin"]) ||
        !this.$root.canShowExSuperAdmin([
          "MANAGE_BARCODE_AGENT",
          "MANAGE_BARCODE_SUB_AGENT",
        ])
      );
    },
    pageTitle() {
      const breadcrumb = {
        MANAGE_MASTER: "จัดการข้อมูล BARCODE",
        MANAGE_BARCODE_AGENT: "จัดการข้อมูล BARCODE (ตัวแทน)",
        MANAGE_BARCODE_SUB_AGENT: "จัดการข้อมูล BARCODE (ตัวแทนจำหน่ายย่อย)",
      };
      let userRoles = this.$root.user.profile.role;
      userRoles = Array.isArray(userRoles)
        ? userRoles
        : userRoles
        ? [userRoles]
        : [];

      // super_admin เห็นทุกสิทธิ์ (canShow() return true เสมอ) → ใช้หัวข้อหลัก
      // ให้ตรงกับเมนูและ breadcrumb
      if (userRoles.includes("super_admin")) {
        return breadcrumb.MANAGE_MASTER;
      }

      // เทียบตามลำดับสิทธิ์ ไม่ใช่ลำดับที่ role มาใน array ของ user
      for (const key of [
        "MANAGE_MASTER",
        "MANAGE_BARCODE_AGENT",
        "MANAGE_BARCODE_SUB_AGENT",
      ]) {
        if (userRoles.includes(key)) {
          return breadcrumb[key];
        }
      }
      return breadcrumb.MANAGE_MASTER;
    },
    filteredProductIdBrandOptions() {
      if (!this.MbBrandId.length)
      {
        return this.ProductIdBrandOptions;
      }
      let filteredOptions = [];
      this.fullProductData.forEach(item => {
        if (this.MbBrandId.map(Number).includes(item.data.productBrandId)) {
          filteredOptions.push({
            id: item.id,
            label: item.text,
            productBrandId: item.data.productBrandId,
          });
        }
      });
      return filteredOptions;
    },
    filteredSubAgentOptions() {
      if (!this.MbHostAgentCode.length)
      {
        return this.reBHostSubAgentCodeOptions;
      }
      return this.fullSubAgentData.filter(item => 
        item.data && this.MbHostAgentCode.includes(item.data)
      ).map(item => ({
        id: item.id,
        label: item.text,
      }));
    },
  },
  methods: {
    clickcheckbox: function(e) {
      
      let self = this;
         setTimeout(function () {
             if(self.MbIsShowCancel){ 
                self.MbBarcodeStautsDisabled = true ;
                self.MbBarcodeStautsId = []; 
              }
              else{
                self.MbBarcodeStautsDisabled = false ;
              }
              
            }, 100);
     
      //self.$parent.saveSummit(this.data.headerId);
    },
    LoadMbCurrentSupplierOptions: _.debounce(function({ action, searchQuery, callback }) {
      var self = this;
      self.MbCurrentSupplierOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Vendors/Select2Vendor", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.MbCurrentSupplierOptions = [];
              if(data.length > 1) self.MbCurrentSupplierOptions = [{id:"0", label:"ทั้งหมด"}];
              data.forEach((element) => {
                self.MbCurrentSupplierOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }

            callback(null, self.MbCurrentSupplierOptions);
          })
          .catch(function(error) {});
      }
    },1000),
    reLoadMbCurrentSupplierOptions: function(){
      this.$refs.MbCurrentSupplierId.trigger.searchQuery = null;
    },
    LoadMbBarcodeStatusOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Barcode/Select2BarcodeStatus", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.MbBarcodeStatusOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    reLoadMbSupplierOptions: function(){
      this.$refs.MbSupplierId.trigger.searchQuery = null;
    },
    LoadMbSupplierOptions({ action, searchQuery, callback }) {
      var self = this;
      self.MbSupplierOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Vendors/Select2Vendor", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.MbSupplierOptions = [];
              data.forEach((element) => {
                self.MbSupplierOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.MbSupplierOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadMbSupShopOptions: _.debounce(function({ action, searchQuery, callback }) {
      var self = this;
      const MbShopId = self.mapMbShop();
      self.MbSupShopOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .post("/Api/Barcode/Select2SupShop", {
            page: 1,
            all: true,
            search: searchQuery,
            ShopId: MbShopId,
            agentCodes: self.MbAgentId,
          })
          .then(function(response) {
            if (response.status == 200) {
              self.MbSupShopOptions = [];
              var data = response.data.results;
              if(data.length > 1) self.MbSupShopOptions = [{id:"0", label:"ทั้งหมด"}];
              data.forEach((element) => {
                self.MbSupShopOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }

            callback(null, self.MbSupShopOptions);
          })
          .catch(function(error) {});
      }
    },1000),
    reLoadMbSupShopOptions: function(){
      this.$refs.MbSupShopId.trigger.searchQuery = null;
    },
    LoadMbSupShop2Options: _.debounce(function({ action, searchQuery, callback }) {
      var self = this;
      const MbShopId = self.mapMbShop();

      self.MbSupShopOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .post("/Api/Barcode/Select2SupShop", {
            page: 1,
            all: true,
            search: searchQuery,
            ShopId: MbShopId,
            agentCodes: self.MbAgentId,
            Name2: true
          })
          .then(function(response) {
            if (response.status == 200) {
              self.MbSupShopOptions = [];
              var data = response.data.results;
              if(data.length > 1) self.MbSupShopOptions = [{id:"0", label:"ทั้งหมด"}];
              data.forEach((element) => {
                self.MbSupShopOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }

            callback(null, self.MbSupShopOptions);
          })
          .catch(function(error) {});
      }
    },1000),
    reLoadMbSupShop2Options: function(){
      this.$refs.MbSupShop2Id.trigger.searchQuery = null;
    },
    LoadMbShopOptions: _.debounce( function({ action , searchQuery, callback }) {
      var self = this;
        axios
          .post("/Api/Barcode/Select2Shop", {
            page: 1,
            all: true,
            search: searchQuery,
            agentCodes: self.MbAgentId,
          })
          .then(function(response) {
            if (response.status == 200) {
              self.MbShopOptions = [];
              var data = response.data.results;
              if(data.length > 1) self.MbShopOptions = [{id:"0", label:"ทั้งหมด"}];
              data.forEach((element) => {
                self.MbShopOptions.push({
                  id: element.id,
                  label: element.text,
                  isDisabled : (self.MbAgentId[0] == "") ? true : false
                });
              });
            }
              callback(null, self.MbShopOptions);
          })
          .catch(function(error) {});
    },1000),
    LoadMbShop2Options: _.debounce( function({ action , searchQuery, callback }) {
      var self = this;
        axios
          .post("/Api/Barcode/Select2Shop", {
            page: 1,
            all: true,
            search: searchQuery,
            agentCodes: self.MbAgentId,
            Name2: true
          })
          .then(function(response) {
            if (response.status == 200) {
              self.MbShopOptions = [];
              var data = response.data.results;
              if(data.length > 1) self.MbShopOptions = [{id:"0", label:"ทั้งหมด"}];
              data.forEach((element) => {
                self.MbShopOptions.push({
                  id: element.id,
                  label: element.text,
                  isDisabled : (self.MbAgentId[0] == "") ? true : false
                });
              });
            }
              callback(null, self.MbShopOptions);
          })
          .catch(function(error) {});
    },1000),
    reLoadMbShopOptions: function(){
      this.$refs.MbShopId.trigger.searchQuery = null;
    },
    reLoadMbShop2Options: function(){
      this.$refs.MbShop2Id.trigger.searchQuery = null;
    },
    LoadMbPlantOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Plant/Select2SearchPlant", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            self.MbPlantOptions = [];
            var data = response.data.results;
            if(data.length > 1) self.MbPlantOptions = [{id:"0", label:"ทั้งหมด"}];
            data.forEach((element) => {
              self.MbPlantOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadMbAgentOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Barcode/Select2SearchAgentName", {
          page: 1,
          all: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            self.MbAgentOptions = [];
            var data = response.data.results;
            if(data.length > 1) self.MbAgentOptions = [{id:"0", label:"ทั้งหมด"}];
            data.forEach((element) => {
              self.MbAgentOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadMbProductTypeIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductType/Select2ProductType", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.MbProductTypeIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadMbAssetOwnerOptions: function(e) {
      var self = this;
      axios
        .get("/Api/assetOwner/Select2SearchAssetOwner", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.MbAssetOwnerOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadMbRefNoOptions({ action, searchQuery, callback }) {
      var self = this;
      self.MbRefNoOptions = [];
      if (action === ASYNC_SEARCH) {
        axios
          .get("/Api/Barcode/Select2RefCode", {
            params: {
              page: 1,
              all: true,
              search: searchQuery,
            },
          })
          .then(function(response) {
            if (response.status == 200) {
              var data = response.data.results;
              self.MbRefNoOptions = [];
              data.forEach((element) => {
                self.MbRefNoOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
            callback(null, self.MbRefNoOptions);
          })
          .catch(function(error) {});
      }
    },
    LoadMbIntendant: _.debounce(function({ action , searchQuery, callback }) {
      var self = this;
        axios
          .post("/Api/Barcode/Select2Intendant", {
            page: 1,
            all: true,
            search: searchQuery,
            ShopCodes: self.MbShopId,
            AgentCodes: self.MbAgentId,
          })
          .then(function(response) {
            if (response.status == 200) {
              self.MbIntendantOptions = [];
              var data = response.data.results;
              if(data.length > 1) self.MbIntendantOptions = [{id:"0", label:"ทั้งหมด"}];
              data.forEach((element) => {
                self.MbIntendantOptions.push({
                  id: element.id,
                  label: element.text,
                });
              });
            }
              callback(null, self.MbIntendantOptions);
          })
          .catch(function(error) {});
    },1000),
    reLoadMbIntendant: function(){
      this.$refs.MbIntendantId.trigger.searchQuery = null;
    },
    LoadMbIntendantSubShop: _.debounce(function({ action , searchQuery, callback }) {
      var self = this;
        axios
          .post("/Api/Barcode/Select2IntendantSubShop", {
            page: 1,
            all: true,
            search: searchQuery,
            ShopCodes: self.MbShopId,
          })
          .then(function(response) {
            if (response.status == 200) {
              self.MbIntendantSubShopOptions = [];
              var data = response.data.results;
              if(data.length > 1) self.MbIntendantSubShopOptions = [{id:"0", label:"ทั้งหมด"}];
              data.forEach((element) => {
                self.MbIntendantSubShopOptions.push({
                  id: element.id,
                  label: element.text,
                  isDisabled : (self.MbIntendantOptions[0] == "") ? true : false
                });
              });
            }
              callback(null, self.MbIntendantSubShopOptions);
          })
          .catch(function(error) {});
    },1000),
    reLoadMbIntendantSubShop: function(){
      this.$refs.MbIntendantSubShopId.trigger.searchQuery = null;
    },
    mapMbShop: function(){
      var self = this;
      const dataSet = [...self.MbShopId, ...self.MbShop2Id];
      const MbShopId = new Set(dataSet);
      return MbShopId;
    },
    mapMbSupShop: function(){
      var self = this;
      const dataSet = [...self.MbSupShopId, ...self.MbSupShop2Id];
      const MbSupShopId = new Set(dataSet);
      return MbSupShopId;
    },
    formReset: function(e) {
      this.MbOldBarcode = "";
      this.MbWarrantyTime = "";
      this.MbExprie = "";
      this.MbProductTypeId = [];
      this.MbAssetOwnerId = [];
      this.MbStatusId = [];
      this.MbDepartmentMaterialCode = "";
      this.MbAccountMaterialCode = "";
      this.MbBarcodeCooling = "";
      this.MbAssetCode = [];
      this.MbBrandId = [];
      this.ProductIdBrand = [];
      this.MbHostAgentCode = [];
      this.MbHostSubAgentCode = [];
      this.MbCurrentLocationType = null;
      this.MbBarcodeYear = [];
      this.MbIntendantSubShopId = [];
      this.MbSupplierId = [];
      this.MbCurrentSupplierId = [];
      this.MbBarcodeStautsId = [];
      this.MbBarcodeStautsDisabled = false ;
      this.MbRefNo = [];
      this.IsLeasedAssets = null;
      this.ActiveStatus = 1; // CR 02/09/2026 — กลับไปที่ค่าเริ่มต้น "ใช้งาน"
      this.MbIsShowCancel =  false;

      $("#MbAgentId").val("").trigger("change");
      this.MbAgentId = [];
      this.MbPlantId = [];

      $("#MbShopId").val("").trigger("change");
      this.MbShopId = [];

      $("#MbShop2Id").val("").trigger("change");
      this.MbShop2Id = [];

      $("#MbSupShopId").val("").trigger("change");
      this.MbSupShopId = [];

      $("#MbSupShop2Id").val("").trigger("change");
      this.MbSupShop2Id = [];

      $("#MbIntendantId").val("").trigger("change");
      this.MbIntendantId = [];

      $("#MbIntendantSubShopId").val("").trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      e.preventDefault();
      var table = $("#barcodeTable").DataTable();
      table.search(this.equipment);
      table.draw();
    },
    reloadDataTable: function(resetPaging = false) {
      $("#barcodeTable")
        .DataTable()
        .ajax.reload(null, resetPaging);
    },
    ClearAfterselect: function() {
      $(`[class="vue-treeselect__input"]`).val("");
    },
    exportBarcode: function(e) {
      e.preventDefault();
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });
 

      axios({
        method: "post",
        url: "/Api/Barcode/ExportBarcode",
        responseType: "arraybuffer",
        data: {
          AgentId: self.MbAgentId,
          PlantId: self.MbPlantId,
          ShopId: self.mapMbShop(),
          SupShopId: self.mapMbSupShop(),
          IntendantId: self.MbIntendantId,
          IntendantSubShopId: self.MbIntendantSubShopId,
          CurrentSupplierId: self.MbCurrentSupplierId,
          OldBarcode: self.MbOldBarcode,
          DepartmentMaterialCode: self.MbDepartmentMaterialCode,
          AccountMaterialCode: self.MbAccountMaterialCode,
          BarcodeCooling: self.MbBarcodeCooling,
          ProductTypeId: self.MbProductTypeId,
          AssetCode: self.MbAssetCode,
          BrandId: self.MbBrandId,
          ProductIdBrand: self.ProductIdBrand,
          HostAgentCode: self.MbHostAgentCode,
          HostSubAgentCode: self.MbHostSubAgentCode,
          AssetOwnerId: self.MbAssetOwnerId,
          CurrentLocationType: self.MbCurrentLocationType,
          BarcodeYear: self.MbBarcodeYear,
          StatusId: self.MbBarcodeStautsId,
          SupplierId: self.MbSupplierId,
          Exprie: self.MbExprie,
          WarrantyTime: self.MbWarrantyTime,
          RefCode: self.MbRefNo,
          IsLeasedAssets: self.IsLeasedAssets,
          ActiveStatus: self.showActiveStatusFilter ? self.ActiveStatus : null,
          IsShowCancel : self.MbIsShowCancel
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          KTApp.unblockPage();
        });
    },
    LoadreBAssetCodeOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Product/Select2Product", {
          params: {
            page: 1,
            all: true,
            excludeProductGroupId : 14
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.MbAssetCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    BrandIdClearAfterSelect: function(){
      this.ProductIdBrand = [];
    },
    BrandIdClearAfterDeSelect: function(){
      this.ProductIdBrand = []; 
    },
    LoadreBBrandIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/ProductBrand/Select2SearchBrandExistProduct", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.MbBrandIdOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    async loadProductData() {
      try {
        const response = await axios.post("/Api/product/Select2ProductReport", {
          page: 1,
          all: true,
          search: "",
          productGroupIds: [14],
        });
        if (response.status === 200) {
          this.fullProductData = response.data.results;
          this.ProductIdBrandOptions = this.fullProductData.map((item) => ({
            id: item.id,
            label: item.text,
            productBrandId: item.data.productBrandId,
          }));
        }
      } catch (error) {
        console.error("Error loading product data:", error);
      }
    },
    AgentCodeClearAfterSelect: function(){
      this.MbHostSubAgentCode = [];
    },
    AgentCodeClearAfterDeSelect: function(){
      this.MbHostSubAgentCode = []; 
    },
    LoadreBHostAgentCodeOptions: function(e) {
      var self = this;
      axios
        .post("/Api/Barcode/Select2SearchAgentName", {
          province_id: [],
          department: [],
          AgentCodes: [],
          page: 1,
          all: true,
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            self.MbHostAgentCodeOptions = [];
            data.forEach((element) => {
              self.MbHostAgentCodeOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    async loadSubAgentOptions() {
      try {
        const response = await axios.post("/Api/Report/Select2SubShopAgent", {
          page: 1,
          onlySubAgent: true,
          onlySubAgentBarcode: true,
          all: true,
        });
        if (response.status === 200) {
          this.fullSubAgentData = response.data.results;
          this.reBHostSubAgentCodeOptions = this.fullSubAgentData.map((item) => ({
            id: item.id,
            label: item.text,
          }));
        }
      } catch (error) {
        console.error("Error loading product data:", error);
      }
    },
    LoadLeasedAssetsOptions: function (e) {
      var self = this;
      self.LeasedAssetsOptions = [];
      var data = [
        { id: 0, text: "ทรัพย์สินบริษัท" },
        { id: 1, text: "ทรัพย์สินเช่า" },
      ];
      data.forEach((element) => {
        self.LeasedAssetsOptions.push({
          id: element.id,
          label: element.text,
        });
      });
    },
    // CR 02/09/2026 — ตัวเลือก filter "สถานะใช้งาน"
    LoadActiveStatusOptions: function (e) {
      var self = this;
      self.ActiveStatusOptions = [
        { id: 1, label: "ใช้งาน" },
        { id: 0, label: "ปิดใช้งาน" },
      ];
    },
    LoadCurrentLocationTypeOptions: function (e) {
      var self = this;
      self.MbCurrentLocationTypeOptions = [];
      var data = [
        { id: "คลัง/โรงงาน", text: "คลัง/โรงงาน" },
        { id: "ตัวแทนจำหน่าย", text: "ตัวแทนจำหน่าย" },
        { id: "ตัวแทนจำหน่ายย่อย", text: "ตัวแทนจำหน่ายย่อย" },
        { id: "ร้านค้า", text: "ร้านค้า" },
        { id: "ร้านค้า (ตัวแทนฯย่อย)", text: "ร้านค้า (ตัวแทนฯย่อย)" },
        { id: "ซัพพลายเออร์", text: "ซัพพลายเออร์" },
      ];
      data.forEach((element) => {
        self.MbCurrentLocationTypeOptions.push({
          id: element.id,
          label: element.text,
        });
      });
    },
    reLoadBarcodeYearOptions: function(){
      this.$refs.MbBarcodeYear.trigger.searchQuery = null;
    },
    LoadBarcodeYearOptions({ action, searchQuery, callback }){
      if (this.AllBarcodeYearOptions.length === 0) {
        axios
          .get("/Api/Report/Select2BarcodeYear", {
            params: {
              page: 1,
              all: true,
            },
          })
          .then((response) => {
            if (response.status === 200) {
              this.AllBarcodeYearOptions = response.data.results.map((element) => ({
                id: element.id,
                label: element.text,
              }));
              callback(null, this.AllBarcodeYearOptions);
            }
          })
          .catch((error) => {
            callback(error, []);
          });
      } else {
        const query = searchQuery ? searchQuery.toLowerCase() : "";
        const filteredOptions = this.AllBarcodeYearOptions.filter((option) =>
          option.label.toLowerCase().includes(query)
        );
        callback(null, filteredOptions);
      }
    },
  },
  async mounted() {
    let self = this;
    self.LoadMbBarcodeStatusOptions();
    self.LoadMbPlantOptions();
    self.LoadMbAgentOptions();
    self.LoadMbProductTypeIdOptions();
    self.LoadMbAssetOwnerOptions();
    self.LoadreBAssetCodeOptions();
    self.LoadreBBrandIdOptions();
    self.LoadreBHostAgentCodeOptions();
    self.LoadCurrentLocationTypeOptions();
    self.loadProductData();
    self.loadSubAgentOptions();
    self.LoadLeasedAssetsOptions();
    self.LoadActiveStatusOptions();

    // CR 02/09/2026 — ปุ่ม Info ของ filter "สถานะใช้งาน"
    self.$nextTick(function () {
      if (self.$refs.ActiveStatusInfo) {
        $(self.$refs.ActiveStatusInfo).popover();
      }
    });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#barcodeTable");
    table
      .DataTable({
        responsive: true,
        processing: true,
        serverSide: true,
        searchDelay: 500,
        ajax: {
          url: "/Api/Barcode/Search",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          beforeSend: function(request) {
            request.setRequestHeader(
              "Authorization",
              "Bearer " + self.$root.user.access_token
            );
          },
          data: function(d) {
            return JSON.stringify(
              $.extend(d, {
                AgentId: self.MbAgentId,
                PlantId: self.MbPlantId,
                ShopId: self.mapMbShop(),
                SupShopId: self.mapMbSupShop(),
                IntendantId: self.MbIntendantId,
                IntendantSubShopId: self.MbIntendantSubShopId,
                CurrentSupplierId: self.MbCurrentSupplierId,
                OldBarcode: self.MbOldBarcode,
                DepartmentMaterialCode: self.MbDepartmentMaterialCode,
                AccountMaterialCode: self.MbAccountMaterialCode,
                BarcodeCooling: self.MbBarcodeCooling,
                ProductTypeId: self.MbProductTypeId,
                AssetCode: self.MbAssetCode,
                BrandId: self.MbBrandId,
                ProductIdBrand: self.ProductIdBrand,
                HostAgentCode: self.MbHostAgentCode,
                HostSubAgentCode: self.MbHostSubAgentCode,
                AssetOwnerId: self.MbAssetOwnerId,
                CurrentLocationType: self.MbCurrentLocationType,
                BarcodeYear: self.MbBarcodeYear,
                StatusId: self.MbBarcodeStautsId,
                SupplierId: self.MbSupplierId,
                Exprie: self.MbExprie,
                WarrantyTime: self.MbWarrantyTime,
                RefCode: self.MbRefNo,
                IsLeasedAssets: self.IsLeasedAssets,
                ActiveStatus: self.showActiveStatusFilter ? self.ActiveStatus : null,
                 IsShowCancel : self.MbIsShowCancel
              })
            );
          },
        },

        // DOM Layout settings
        dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,
        lengthMenu: [50, 100, 200, 500],
        pageLength: 100,
        language: {
          lengthMenu: "Display _MENU_",
        },
        // Order settings
        order: [[0, "desc"]],
        columns: [
          { data: "barcodeIdOld" },
          { data: "departmentMaterialCode" },
          { data: "accountMaterialCode" },
          { data: "barcodeCooling" },
          { data: "materialCode" },
          { data: "materialDesc" },
          { data: "productTypeName" },
          { data: "finishedProductCode" },
          { data: "beerDetail" },
          { data: "status" ,
            render: function(data, type, full, meta) {
              if (full.inActiveStatus) {
                return "<span style='color:red !important;'>ยกเลิก</span>";
              } 
              else{
                return data ;
              }
            }
          },
          { data: "locations" ,
            render: function(data, type, full, meta) {
              if (data === null || data === undefined) {
                return "";
              }
              var html = "<pre style='font-size: 15px; font-weight: 300; font-family: Noto Sans Thai UI;color: #6c7293;display:inline;white-space: pre-wrap; word-break: keep-all;'>"+data+"</pre>";
              return html;
            }
          },
          { data: "hostAgentName" },
          { data: "currentLocationType" },
          { data: "refCode" },
          {
            data: "warrantyStartDate",
            className: "text-center",
            render: function(data, type, full, meta) {
              return full.warrantyStartDateS;
            },
          },
          { data: "warrantyTime" },
          { data: "exprie" },
          { data: "supplierName" },
          {
            data: "barcodeId",
            className: "text-center",
            width: "15%",
            orderable: false,
            render: function(data, type, full, meta) {
              return '<div class="actions"></div>';
            },
          },
        ],
      })
      .on("preXhr.dt", function() {
        KTApp.block(self.$refs.searchForm, {
          showOverlay: false,
          opacity: 0.05,
          message: "กำลังค้นหาข้อมูล กรุณารอสักครู่...",
        });
      })
      .on("xhr.dt", function() {
        KTApp.unblock(self.$refs.searchForm);
      })
      .on("error.dt", function ( e, settings, techNote, message ) {
        DatatableWarning.alert(techNote);
      })
      .on("draw.dt", function() {
        $(".actions").each(function(i, el) {
          var $dt = table.DataTable();
          var $tr = $(el)
            .parents("tr")
            .first();

          var data = $dt.row($tr).data();
          if (data) {
 
            console.log(data);
            //alert( data.inActiveStatus); //&& data.status  !="ยกเลิก"
            var isShowCacelBarcodeButtonByCode = false ;
            if((data.materialCode =="COOL-ROOM-01" || data.materialCode =="FONT-SHOP-01" ) && data.inActiveStatus == false){
              isShowCacelBarcodeButtonByCode = true ;
            }

            data.showDetailButton = self.$root.canShow([
              "MANAGE_MASTER","MANAGE_BARCODE_AGENT","MANAGE_BARCODE_SUB_AGENT"
            ]);
            data.showEditBarCodeButton = self.$root.canShow([
              "super_admin",
              "MANAGE_MASTER",
            ]);
             data.showCancelBarCodeButton = (isShowCacelBarcodeButtonByCode  && self.$root.canShow([
              "super_admin",
              "MANAGE_MASTER","MANAGE_BARCODE",
              ,"MANAGE_BARCODE_AGENT","MANAGE_BARCODE_SUB_AGENT" 
            ]));
            

            new Actions({ data: { data }, parent: self }).$mount(el);
          }
        });
      });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Master/Barcode/ManageBarcode.vue